import { useEffect, useState, type FormEvent } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "动漫资讯", to: "/news" },
  { label: "作品推荐", to: "/recommendations" },
  { label: "关于78动漫", to: "/about" },
];

export default function SiteHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.search]);

  const isActive = (to: string) => {
    if (to === "/") return location.pathname === "/";
    return location.pathname.startsWith(to);
  };

  const handleSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
    setKeyword("");
    setMenuOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center justify-between gap-4 md:h-[72px]">
          <Link to="/" className="flex shrink-0 items-center gap-2.5 cursor-pointer">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-movie-2-line text-xl" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
                78动漫
              </span>
              <span className="mt-0.5 text-[10px] font-label uppercase tracking-[0.18em] text-foreground-500">
                Anime Portal
              </span>
            </span>
          </Link>

          <nav className="hidden items-center gap-1 lg:flex">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium transition-colors cursor-pointer ${
                  isActive(item.to)
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <form onSubmit={handleSearch} className="hidden md:block">
              <div className="flex items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-1.5 transition-colors focus-within:border-primary-400">
                <span className="flex h-5 w-5 items-center justify-center text-foreground-500">
                  <i className="ri-search-line text-base" />
                </span>
                <input
                  type="text"
                  value={keyword}
                  onChange={(event) => setKeyword(event.target.value)}
                  placeholder="搜索资讯或作品"
                  className="w-32 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none xl:w-44"
                />
              </div>
            </form>

            <Link
              to="/search"
              className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 bg-background-100 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 md:hidden cursor-pointer"
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg" />
            </Link>

            <button
              type="button"
              onClick={() => setMenuOpen((prev) => !prev)}
              className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 bg-background-100 text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600 lg:hidden cursor-pointer"
              aria-label="打开菜单"
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden animate-fade-in">
          <div className="w-full px-4 py-4 md:px-8">
            <form onSubmit={handleSearch} className="mb-4 md:hidden">
              <div className="flex items-center gap-2 rounded-lg border border-background-300 bg-background-100 px-3 py-2.5 focus-within:border-primary-400">
                <span className="flex h-5 w-5 items-center justify-center text-foreground-500">
                  <i className="ri-search-line text-base" />
                </span>
                <input
                  type="text"
                  value={keyword}
                  onChange={(event) => setKeyword(event.target.value)}
                  placeholder="搜索资讯或作品"
                  className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
                />
              </div>
            </form>
            <div className="flex flex-col gap-1">
              {navItems.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  className={`flex items-center justify-between rounded-md px-4 py-3 text-sm font-medium transition-colors cursor-pointer ${
                    isActive(item.to)
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100"
                  }`}
                >
                  {item.label}
                  <i className="ri-arrow-right-s-line text-lg text-foreground-400" />
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}